import { apiClient } from './client'

export type TrophyMaterial =
  | { kind: 'achievement'; id: number; name: string; tags?: string[]; rating?: number; summary?: string }
  | { kind: 'trophy'; id: number; name: string; title?: string; rarity?: number }

export type OriginalTrophy = {
  id: number
  name: string
  title: string
  skill: string
  self_pr: string
  rarity: number // 1-10
  material: TrophyMaterial[]
  supplement: string
  position: number | null
  created_at: string
}

export type GenerateMaterial = { kind: 'achievement' | 'trophy'; id: number }
export type LayoutItem = { id: number; position: number | null }

export type TrophyQuota = {
  hold_count: number
  max_hold: number
  remaining_free: number
  generated_today: number
  daily_limit: number
  max_materials: number
  can_generate: boolean
}

export const getOriginalTrophies = () =>
  apiClient.get<OriginalTrophy[]>('/trophies/original/').then((r) => r.data)

export const getTrophyQuota = () =>
  apiClient.get<TrophyQuota>('/trophies/original/quota/').then((r) => r.data)

export const generateOriginalTrophy = (materials: GenerateMaterial[], supplement: string) =>
  apiClient
    .post<OriginalTrophy>('/trophies/original/generate/', { materials, supplement })
    .then((r) => r.data)

export const deleteOriginalTrophy = (id: number) =>
  apiClient.delete(`/trophies/original/${id}/`).then((r) => r.data)

export const saveOriginalLayout = (items: LayoutItem[]) =>
  apiClient.post('/trophies/original/layout/', items).then((r) => r.data)
